import { CloudUploadOutlined, FileAddOutlined } from '@ant-design/icons';
import { cloneDeep } from 'lodash';
import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import { Button } from 'reactstrap';
import { showToaster, toasterTypes } from '..';
import { MESSAGES } from '../../utils/Constants';


export default function ResearchWorkUpload(props: any) {
    const [files, setfiles] = useState([]);

    function onUpload(acceptedFiles: any) {
        let files = props.acceptFiles.split('|');
        for (let j = 0; j < acceptedFiles.length; j++) {
            console.log(acceptedFiles[j].size)
             if (acceptedFiles[j].size > 2000000) {
                showToaster(toasterTypes.ERROR, "File size cannot exceed 2MB");
                return;
            }
        };
        setfiles(acceptedFiles);
        props.onUpload(acceptedFiles);
        showToaster(toasterTypes.SUCCESS, "File Uploaded Successfully!");
    }
    const deleteFile = (index: any, e: any) => {
        let temp = cloneDeep(files);
        temp.splice(index, 1);
        setfiles(temp);
        e.stopPropagation();
    }

    return (
        <div className='custom-research-upload'>
            <Dropzone onDrop={acceptedFiles => onUpload(acceptedFiles)} disabled={props.isDisabled}>
                {({ getRootProps, getInputProps }) => (
                    <section>
                        <div {...getRootProps()} className={`${(props.touched && props.error) ? 'error-field' : ''} upload-container`}>
                            <input {...getInputProps()} />

                            {files.length === 0 ?
                                <p><span className='upload-placeholder'><CloudUploadOutlined className="Upload-icon"/>{props.placeholder}</span><u className='browse-text'>Browse Files</u></p> :
                                <div>
                                    {files.map((obj: any, index) => (
                                        <div  key={index}>{obj.name}
                                            <img alt="close" src={`${process.env.PUBLIC_URL}/images/close_circle.svg`} onClick={(e) => deleteFile(index, e)} />
                                            <FileAddOutlined/>
                                        </div>
                                    ))}

                                </div>
                            }
                        </div>
                    </section>
                )}
            </Dropzone>
        </div>
    )
}
